import { readonly, ref } from 'vue'

const activeHolds = ref(0)
const isStartupSplashVisible = ref(false)

export function holdStartupSplash() {
  activeHolds.value += 1
  isStartupSplashVisible.value = true

  let released = false
  return () => {
    if (released) return

    released = true
    activeHolds.value = Math.max(0, activeHolds.value - 1)
    isStartupSplashVisible.value = activeHolds.value > 0
  }
}

export function useStartupSplash() {
  return {
    isStartupSplashVisible: readonly(isStartupSplashVisible),
  }
}
